import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  labelStyle: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "normal",
    textAlign: "left",
    color:"#757575",
    marginBottom:"0.25rem",
    marginLeft: "0.25rem",
  },
});
export const InputLabel = ({ name, value, className, ...props }) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <label htmlFor={name} className={classes.labelStyle} style={{marginBottom:"0.25rem"}} >
        {value}
      </label>
    </React.Fragment>
  );
};

InputLabel.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};
